import React, { useEffect } from "react";
import { Col, Container, Row } from "reactstrap";

// redux toolkit
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { fetchAnnouncements } from "../../slices/apps/announcementSlice";

// sayfalar, modallar vb.
import AnnouncementTable from "./AnnouncementTable";

const Announcements = () => {
  const dispatch = useDispatch();

  const { announcementsRefresh } = useSelector((state) => {
    return {
      announcementsRefresh: state.announcement.announcementsRefresh,
    };
  }, shallowEqual);

  const fetchData = async () => {
    try {
      await dispatch(fetchAnnouncements());
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [dispatch, announcementsRefresh]);

  document.title = "Duyuru Listesi | Global Yol Yardım";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xxl={12}>
              <AnnouncementTable />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default Announcements;
